//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SvgFilterMixin',
  data: function data() {
    return {
      filterId: ''
    };
  },
  computed: {
    filterUrl: function filterUrl() {
      return "url(#".concat(this.filterId, ")");
    }
  },
  mounted: function mounted() {
    this.filterId = 'invertIconApps' + Math.floor(Math.random() * 100) + new Date().getSeconds() + new Date().getMilliseconds();
  }
};